/**
 * Adds odd/even class alternately to given tag
 *
 * @access  public
 * @return  jQuery
 */
$.fn.oddEven = function () {
    return this.each(function (i) {
        $(this).removeClass('odd even').addClass(i % 2 === 0 ? 'even' : 'odd');
    });
};
